export const currencyFormatter = (num) => {
	if (num) return new Intl.NumberFormat().format(Math.round(num));
	return 0;
};

export const toToman = (value) => {
	return value ? currencyFormatter(Number(value) / 10) : 0;
};
